export default __webpack_public_path__ + "static/media/jamui_bihar_3k-2.1e303176.webp";